import React, {useState} from "react";
import {CompletePayroll} from "../../../../app/interfaces";
import {EorPartnerPaidContainer} from "./styles";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {updatePayrollState} from "../../../../app/payroll/selectors";
import {updatePayroll} from "../../../../app/payroll/actions";
import {FETCH_STATUS_LOADING, PAYROLL_STATUS_EOR_PARTNER_PAID} from "../../../../utils/constants";
import {PopupAskForConfirmation, PopupLoading, PrimaryButton} from "../../../../components";
import PayrollDetailsView from "../PayrollDetailsView";

const PayrollPartnerPayment = ({payroll}: {payroll: CompletePayroll}) => {
    const {t} = useTranslation();
    const dispatch = useDispatch();

    const statusUpdate = useSelector(updatePayrollState)
    const [showAskForConfirmation, setShowAskForConfirmation] = useState<boolean>(false)

    const handleEorPartnerAsPaid = () => {
        setShowAskForConfirmation(false)
        dispatch(updatePayroll(
            {
                payrollId: payroll._id,
                employeeId: payroll.eor_employee._id,
                status: PAYROLL_STATUS_EOR_PARTNER_PAID
            }
        ) as any)
    }

    if(statusUpdate === FETCH_STATUS_LOADING){
        return <PopupLoading isOpen={true}/>
    }

    return <>
        {showAskForConfirmation && <PopupAskForConfirmation
            title={t('wait_a_minute') as string}
            subtitle={t('mark_eor_partner_paid_warning') as string}
            isOpen={showAskForConfirmation}
            onConfirm={handleEorPartnerAsPaid}
            onCancel={() => setShowAskForConfirmation(false)}
            type='hand_stop'
        />}

        <EorPartnerPaidContainer>
            <div className="label">
                <h1>{t('mark_partner_as_paid_title')}</h1>
                <h3>{t('mark_partner_as_paid_message')}</h3>
            </div>
            <div className="action">
                <PrimaryButton onClick={() => setShowAskForConfirmation(true)}>
                    {t('mark_eor_partner_paid')}
                </PrimaryButton>
            </div>
        </EorPartnerPaidContainer>
        <PayrollDetailsView payroll={payroll}/>
    </>
}

export default PayrollPartnerPayment;
